import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

const TRAILING_NODE_PLUGIN_KEY = new PluginKey('trailingNode');

const TEXT_BLOCK_TYPES = new Set(['paragraph', 'heading']);

export const TrailingNode = Extension.create({
  name: 'trailingNode',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: TRAILING_NODE_PLUGIN_KEY,
        appendTransaction(_transactions, _oldState, newState) {
          const { doc, schema } = newState;
          const lastChild = doc.lastChild;

          if (!lastChild || TEXT_BLOCK_TYPES.has(lastChild.type.name)) {
            return null;
          }

          const paragraph = schema.nodes.paragraph.create();
          const tr = newState.tr.insert(doc.content.size, paragraph);
          tr.setMeta('addToHistory', false);
          tr.setMeta(TRAILING_NODE_PLUGIN_KEY, true);

          return tr;
        },
      }),
    ];
  },
});
